"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSortableHoc = require("react-sortable-hoc");

var _ArrayFieldSortableItem = _interopRequireDefault(require("./ArrayFieldSortableItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const ArrayFieldSortableList = (0, _reactSortableHoc.sortableContainer)(props => {
  const arrayProps = props.arrayProps,
        items = props.items;
  const registry = arrayProps.registry,
        canAdd = arrayProps.canAdd,
        onAddItem = arrayProps.onAddItem,
        onChange = arrayProps.onChange;
  const SchemaLayout = registry.fields.SchemaLayout;
  return _react.default.createElement(SchemaLayout, _extends({}, arrayProps, {
    onAdd: canAdd && onAddItem,
    onChange: onChange
  }), items.map((value, index) => {
    const itemProps = _extends({}, arrayProps, {
      itemIndex: index
    });

    return _react.default.createElement(_ArrayFieldSortableItem.default, _extends({}, itemProps, {
      value: value,
      index: index,
      key: "item-" + index
    }));
  }));
});
var _default = ArrayFieldSortableList;
exports.default = _default;
module.exports = exports.default;